import { render } from "./OrderListComp.vue?vue&type=template&id=4d3458fd"
import script from "./OrderListComp.vue?vue&type=script&lang=js"
export * from "./OrderListComp.vue?vue&type=script&lang=js"

import "./OrderListComp.vue?vue&type=style&index=0&id=4d3458fd&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__